import type { StepConfig } from "@portal/components/multiform/types";
import type { AdminCombinedFormData } from "../../schema";
import { HistoryStep } from "./HistoryStep";
import { HistorySummary } from "./HistorySummary";

export const historyStepConfig: StepConfig<AdminCombinedFormData> = {
	name: "history",
	label: "History",
	fieldPaths: ["account.history"],
	component: HistoryStep,
	summaryComponent: HistorySummary,
};
